import React from 'react';
import { Form, Row, Col, Input, Select, DatePicker, InputNumber, Divider } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';

const { Option } = Select;

const ProposalForm = ({
  form,
  proposalData,
  updateProposalField,
  isUpdatingForm,
}) => (
  <Form
    form={form}
    layout="vertical"
    size="small"
    onFieldsChange={(changedFields) => {
      if (isUpdatingForm.current) return;
      changedFields.forEach(field => {
        if (!field.name || !field.name[0]) return;
        let value = field.value;
        const fieldName = field.name[0];
        try {
          if (['date', 'expiryDate', 'sailingDate'].includes(fieldName)) {
            if (dayjs.isDayjs(value) && value.isValid()) {
              value = value.format('YYYY-MM-DD');
            } else if (value) {
              const converted = dayjs(value);
              value = converted.isValid() ? converted.format('YYYY-MM-DD') : '';
            } else {
              value = '';
            }
          }
          updateProposalField(fieldName, value);
        } catch (error) {
          console.error(`Erro ao atualizar campo ${fieldName}:`, error);
        }
      });
    }}
  >
    <Row gutter={[8, 0]}>
      <Col span={24}>
        <Form.Item name="quotationNo" label="Nº Cotação">
          <Input placeholder="WLI000000005" />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[8, 0]}>
      <Col span={12}>
        <Form.Item name="from" label="Origem">
          <Input placeholder="BRSSZ Santos" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="to" label="Destino">
          <Input placeholder="SRPBM Paramaribo" />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[8, 0]}>
      <Col span={12}>
        <Form.Item name="mode" label="Modal">
          <Select placeholder="SEA-FCL">
            <Option value="SEA-FCL">SEA-FCL</Option>
            <Option value="SEA-LCL">SEA-LCL</Option>
            <Option value="AIR">AIR</Option>
            <Option value="ROAD">ROAD</Option>
            <Option value="RAIL">RAIL</Option>
          </Select>
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="containerType" label="Tipo Container">
          <Select placeholder="20GP">
            <Option value="20GP">20GP</Option>
            <Option value="40GP">40GP</Option>
            <Option value="40HC">40HC</Option>
            <Option value="45HC">45HC</Option>
            <Option value="20RF">20RF (Reefer)</Option>
            <Option value="40RF">40RF (Reefer)</Option>
            <Option value="20OT">20OT (Open Top)</Option>
            <Option value="40OT">40OT (Open Top)</Option>
            <Option value="20FR">20FR (Flat Rack)</Option>
            <Option value="40FR">40FR (Flat Rack)</Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[8, 0]}>
      <Col span={12}>
        <Form.Item name="grossWeight" label="Peso Bruto">
          <Input placeholder="20,000.00 KG" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="incoTerms" label="Incoterms">
          <Select placeholder="FOB">
            <Option value="EXW">EXW - Ex Works</Option>
            <Option value="FCA">FCA - Free Carrier</Option>
            <Option value="CPT">CPT - Carriage Paid To</Option>
            <Option value="CIP">CIP - Carriage and Insurance Paid To</Option>
            <Option value="DAP">DAP - Delivered at Place</Option>
            <Option value="DPU">DPU - Delivered at Place Unloaded</Option>
            <Option value="DDP">DDP - Delivered Duty Paid</Option>
            <Option value="FAS">FAS - Free Alongside Ship</Option>
            <Option value="FOB">FOB - Free on Board</Option>
            <Option value="CFR">CFR - Cost and Freight</Option>
            <Option value="CIF">CIF - Cost, Insurance and Freight</Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[8, 0]}>
      <Col span={12}>
        <Form.Item name="carrier" label="Transportadora">
          <Select placeholder="Selecione a transportadora">
            <Option value="MAERSK">Maersk</Option>
            <Option value="MSC">MSC</Option>
            <Option value="CMA CGM">CMA CGM</Option>
            <Option value="HAPAG-LLOYD">Hapag-Lloyd</Option>
            <Option value="ONE">ONE</Option>
            <Option value="EVERGREEN">Evergreen</Option>
            <Option value="COSCO">COSCO</Option>
            <Option value="ZIM">ZIM</Option>
            <Option value="YANG MING">Yang Ming</Option>
            <Option value="PIL">PIL</Option>
          </Select>
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="transitTime" label="Tempo Trânsito">
          <Input placeholder="35 DAYS" />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[8, 0]}>
      <Col span={8}>
        <Form.Item name="date" label="Data Cotação">
          <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Data da cotação" />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item name="expiryDate" label=" Data Validade">
          <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Data de expiração" />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item name="sailingDate" label="Data Embarque">
          <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Data de embarque" />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[8, 0]}>
      <Col span={12}>
        <Form.Item name="freetimeOrigem" label="Freetime Origem">
          <Input style={{ width: '100%' }} min={0} max={999} onChange={(value) => updateProposalField("freeTimeOrigem", value)} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="freetimeDestino" label="Freetime Destino">
          <Input style={{ width: '100%' }} min={0} max={999} onChange={(value) => updateProposalField("freeTimeDestino", value)} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="serviceType" label="Tipo Serviço">
          <Select placeholder="CY/CY" disabled>
            <Option value="CY/CY">CY/CY - Container Yard to Container Yard</Option>
            <Option value="CFS/CFS">CFS/CFS - Container Freight Station to CFS</Option>
            <Option value="CY/CFS">CY/CFS - Container Yard to CFS</Option>
            <Option value="CFS/CY">CFS/CY - Container Freight Station to CY</Option>
            <Option value="DOOR/DOOR">Door to Door</Option>
            <Option value="DOOR/CY">Door to Container Yard</Option>
            <Option value="CY/DOOR">Container Yard to Door</Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[8, 0]}>
      <Col span={12}>
        <Form.Item name="commodity" label="Commodity">
          <Input placeholder="GENERAL CARGO" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="route" label="Rota">
          <Input placeholder="Santos - Hamburg" />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[8, 0]}>
      <Col span={24}>
        <Form.Item name="terms" label="Termos e Observações">
          <TextArea rows={6} placeholder="Termos especiais, observações ou condições adicionais..." />
        </Form.Item>
      </Col>
    </Row>
    <Divider />
  </Form>
);

export default ProposalForm;
